
import { Card, makeStyles } from "@material-ui/core";
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import Loading from "../../../../load/loading";
import Date from "../../../../utils/date";
import { useNavigate } from "react-router-dom";
import ListaVazia from "../../../../utils/listaVazia";
import FerramentaNavegacaoExportacao from "../../../../utils/paginacao";


const useStyles = makeStyles((theme) => ({
    hover: { '&:hover': { backgroundColor: '#85287d8a' }, cursor: 'pointer' },
    container: {
        display: 'flex',
        justifyContent: 'center',
        boxShadow: 'none',
        margin: 10
    },
}))

export default function ListaNotificacoes({ notificacoes, configLista, page, setPage, setPerPage }) {
    const classes = useStyles()
    const navigate = useNavigate()

    return (
        notificacoes
            ?
            notificacoes.length > 0 ?

                <Card variant="outlined" sx={{ width: '100%', overflow: 'hidden' }} >
                    <TableContainer sx={{ border: "1px black" }} component={Paper}>
                        <Table sx={{ border: "1px", borderColor: "black" }}>
                            <TableHead sx={{ backgroundColor: "#dcdede" }}>
                                <TableRow>
                                    <TableCell align="center" ><Typography noWrap> <strong>Unidade Sanitária / Farmácia </strong></Typography></TableCell>
                                    <TableCell align="center" ><Typography noWrap> <strong>Nome do produto DCI </strong></Typography></TableCell>
                                    <TableCell align="center" ><Typography noWrap> <strong>Nome comercial </strong></Typography></TableCell>
                                    <TableCell align="center" ><Typography noWrap> <strong> Tipo de notificação </strong></Typography></TableCell>
                                    <TableCell align="center" ><Typography noWrap> <strong> Nº Entrada </strong></Typography></TableCell>
                                    <TableCell align="center" ><Typography noWrap> <strong> Notificador </strong></Typography></TableCell>
                                    <TableCell align="center" ><Typography noWrap> <strong> Categoria profissional </strong></Typography></TableCell>
                                    <TableCell align="center" ><Typography noWrap> <strong> Data Notificação </strong></Typography></TableCell>
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {notificacoes.map((notificacao) => (
                                    <TableRow key={notificacao._id} className={classes.hover} onClick={() => navigate(`/admin/farmacovigilancia/view/notificacao/${notificacao._id}`)}>

                                        <TableCell ><Typography noWrap> {notificacao?.unidadeSanitaria?.nome}</Typography></TableCell>
                                        <TableCell ><Typography noWrap> {notificacao?.identificacaoProducto[0]?.nomeDCI}</Typography></TableCell>
                                        <TableCell ><Typography noWrap> {notificacao?.identificacaoProducto[0]?.nomeComercial}</Typography></TableCell>
                                        <TableCell  ><Typography noWrap> {notificacao?.tipo}</Typography></TableCell>
                                        <TableCell align="center"   ><Typography noWrap> {notificacao?.numero} </Typography></TableCell>
                                        <TableCell  ><Typography noWrap> {notificacao?.notificador?.nome}</Typography></TableCell>
                                        <TableCell  ><Typography noWrap> {notificacao?.notificador?.categoriaProfissional}</Typography></TableCell>
                                        <TableCell align="center" ><Typography noWrap> <Date date={notificacao?.createdAt} /> </Typography></TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>

                        <FerramentaNavegacaoExportacao
                            configLista={configLista}
                            lista={notificacoes}
                            page={page}
                            setPage={setPage}
                            setPerPage={setPerPage}
                        />

                    </TableContainer>
                </Card>
                :
                <ListaVazia />
            :
            <Loading text={'A carregar notificacoes'} />
    )
}